export default "__VITE_ASSET__BDzEw3$I__"